BX.addCustomEvent("DevBxWebFormCreated", function(app) {

    app.component('devbx-webform-mode-init', {
        template: `
        <div style="display: none">
            <devbx-webform-page
                v-for="page in $root.webForm.pages.items" 
                :key="page.id"
                :page="page" 
                :is-active="false"
                :disable-actions="true"
            ></devbx-webform-page>            
        </div>
        `
    });
});